module.exports = __webpack_public_path__ + "img/0-40.bfb1fdf5.jpg";